// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-admin-template-admin-js": () => import("/home/circleci/repo/packages/brikl-shop-client/src/admin-template/admin.js" /* webpackChunkName: "component---src-admin-template-admin-js" */)
}

